import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: "app-sign-demo",
  templateUrl: "./sign-demo.component.html",
  styleUrls: ["./sign-demo.component.scss"],
})
export class SignDemoComponent implements OnInit {
  inputText: string = "";
  textToSign: string = "";
  resultText: boolean | null = null;
  
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {}
  
  ngOnInit() {
    this.dataService.breadcrumbsArray.next([...this.activatedRoute.snapshot.data['breadcrumbs']])
  }

  signText() {
    this.textToSign = this.inputText;
  }

  receiveResult(result: boolean) {
    this.resultText = result;
  }
}
